var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myapps"},_vm._l((_vm.userAvailableApps),function(app){return _c('App',{key:app.key,attrs:{"app":app,"isClick":_vm.goToOtherApp}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }